import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import CustomCountryState from "@MasterBluePrint/Store/Components/CustomCountry/CustomCountryState";
import { Draft } from "immer";

const initialState: CustomCountryState = {
    countryCode:""
};

const reducer = {
    "Components/CustomCountry/SetCountryCode": (
        draft: Draft<CustomCountryState>,
        action: {
            countryCode: string;
        },
    ) => {
        draft.countryCode = action.countryCode;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);